import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

import { WorkFlowService } from '../../../services/workflow.service';

import { AssignUsersModal, UpdateWorkflowGroupModal } from '../../../modals';
import { NewWorkflowModal } from '../../../modals/new-workflow/new-workflow.component';
interface Unit {
  organizationUnitId: string;
  organizationId: string;
  unitName: string;
  actionAdditionalDetails: string;
  dateCreated: string;
  dateModified: string;
  createdBy: string;
  modifiedBy: string;
}
@Component({
  selector: 'app-workflow-groups',
  templateUrl: './workflow-groups.component.html',
  styleUrls: ['./workflow-groups.component.scss'],
})
export class WorkflowGroupsComponent implements OnInit {
  workflowGroups;
  filter: AppFilter;
  pending: boolean;
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  fields;
  error;
  success;
  units: Array<Unit>;
  selectedUnit: any;
  organizationId = localStorage.getItem('organizationId');

  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'workflowGroupDescription',
        op: 'cn',
        data: '',
      },
    ],
  };
  orgPending;
  workflow;
  selectedCategory;
  users = [];

  constructor(
    private location: Location,
    public modalService: SuiModalService,
    private workflowService: WorkFlowService
  ) {
    this.filter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });
    this.workflow = JSON.parse(window.localStorage.getItem('workflow'));
    this.unitFilter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      rows: 1000,
      sord: 'desc',
    });
  }

  goBack() {
    this.location.back();
  }

  searchRecords(event) {
    this.searchFilter.rules[0].data = event;
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.getPage(this.currentPage);
  }

  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(this.currentPage);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(this.currentPage);
  }

  nextPage(page) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  assignUsers(group) {
    let users = [];
    group.users.forEach((user) => {
      users.push(JSON.parse(user)['app_user_id']);
    });

    this.modalService
      .open(
        new AssignUsersModal(
          `Assign Users to ${group['workflowGroupName']} Group`,
          group,
          users,
          false,
          ModalSize.Small
        )
      )
      .onApprove((value) => {

        this.success = value;

        this.getPage(this.currentPage);
      })
      .onDeny(() => {
        this.getPage(this.currentPage);
      });
  }

  getPage(page) {
    this.pending = true;
    this.filter.page = page;
    this.workflowService
      .workflowGraph({
        organizationUnitId: this.organizationId,
        workflowGroupId:
          this.workflow['jpaWorkflowGroupViewPK']['workflowGroupId'],
        workflowType: this.workflow['jpaWorkflowGroupViewPK']['workflowType'],
      })
      .subscribe(
        (e) => {
          this.pending = false;
          this.workflowGroups = e['rows'];
          this.workflowGroups.forEach((group) => {
            group.users.forEach((user) => {
              this.users.push({
                id: group.workflowGroupId,
                users: JSON.parse(user),
              });
            });
          });
          this.totalItems = +e['records'];
          this.rows = this.filter.rows;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  ngOnInit(): void {
    this.pending = true;
    this.getPage(this.currentPage);
  }

  unitFilter: AppFilter;

  close() {
    this.success = null;
    this.error = null;
  }
}
